import React from 'react';
import { Link } from 'react-router-dom';
import LanguageSwitcher from './LanguageSwitcher';

const PrivacyPolicyPage = ({ language, setLanguage, t, app }) => {
  console.log('PrivacyPolicyPage props', { t, app, language });
  
  // Get the correct policy based on app
  const getPolicyData = () => {
    switch (app) {
      case 'quitsnus':
        return t?.quitSnusPrivacy;
      case 'mrpiggy':
        return t?.mrPiggyPrivacy;
      case 'quitsmoking':
        return t?.quitSmokingPrivacy;
      case 'nero-diamante':
        return t?.neroDiamantePrivacy;
      default:
        return null;
    }
  };

  // Get the correct back link
  const getBackLink = () => {
    switch (app) {
      case 'quitsnus':
        return '/quitsnus';
      case 'mrpiggy':
        return '/mrpiggy';
      case 'quitsmoking':
        return '/quitsmoking';
      case 'nero-diamante':
        return '/nero-diamante';
      default:
        return '/';
    }
  };

  const policy = getPolicyData();

  if (!policy || !t) {
    console.error(`Policy not found for app: ${app}`, { t, language });
    return (
      <div className="app-page-container">
        <div className="content-wrapper">
          <LanguageSwitcher language={language} setLanguage={setLanguage} />
          <Link to={getBackLink()} className="back-btn">
            <svg width="18" height="18" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            {t?.back || 'Back'}
          </Link>
          <section className="app-hero">
            <h1>Error</h1>
            <p>Privacy policy not found. Please try again later.</p>
          </section>
        </div>
      </div>
    );
  }

  return (
    <div className="app-page-container">
      <div className="content-wrapper">
        <LanguageSwitcher language={language} setLanguage={setLanguage} />
        
        <Link to={getBackLink()} className="back-btn">
          <svg width="18" height="18" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          {t.back || 'Back'}
        </Link>

        <section className="app-hero">
          <div className="app-icon-section">
            <h1 className="app-title">{policy.title}</h1>
            <p className="app-subtitle">{policy.lastUpdated}</p>
          </div>
        </section>

        <div className="app-main-content">
          <div className="about-section">
            {Object.entries(policy.sections || {}).map(([key, section]) => (
              <div key={key} className="policy-section">
                <h2 className="section-title">{section.title}</h2>
                <div className="about-text">
                  <p>{section.content}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <footer className="app-footer">
          <div className="footer-content">
            <div className="footer-links">
              <Link to="/">{t.ourApps || 'Home'}</Link>
              <Link to="/quitsnus">{t.quitSnusTitle || 'QuitSnus'}</Link>
              <Link to="/mrpiggy">{t.mrPiggyTitle || 'Mr Piggy'}</Link>
              <Link to="/quitsmoking">{t.quitSmokingTitle || 'QuitSmoking'}</Link>
              <Link to="/nero-diamante">{t.neroDiamanteTitle || 'Nero Diamante'}</Link>
            </div>
            <div className="footer-legal">
              <Link to={`/${app}-privacy`}>{t.privacyPolicy || 'Privacy Policy'}</Link>
              <Link to={`/${app}-terms`}>{t.termsOfUse || 'Terms of Service'}</Link>
            </div>
            <div className="footer-copyright">
              <p>{t.footerCopyright || '© 2025 Sunny Software. All rights reserved.'}</p>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;